import { useState } from 'react';
import { useTranslation } from 'react-i18next';
import { useQuery } from '@tanstack/react-query';

import { emsApi } from '@/api/emsApi';
import { LoadingFailedBox, NgPageHeader } from '@/ui';

import type { ChecklistDto } from './checklistFiltering';
import { filterChecklists } from './checklistFiltering';
import { ChecklistListComponent } from './ChecklistListComponent';
import { ChecklistListLoadingPlaceholder } from './ChecklistListLoadingPlaceholder';
import { CheckListSearchComponent } from './CheckListSearchComponent';

async function fetchChecklists(): Promise<ChecklistDto[]> {
  const { data, response } = await emsApi.GET('/portal/v1/checklists');
  if (data === undefined) {
    throw new Error(`Failed to load checklists (HTTP ${response.status})`);
  }
  return data;
}

export function ChecklistListPage() {
  const { t } = useTranslation();
  const pageTitle = t('PageTitle_ListOfChecklists');

  const [searchText, setSearchText] = useState<string | null>(null);

  const {
    data: checklists,
    isError: showError,
    isFetching: isLoading,
  } = useQuery({ queryKey: ['checklists'], queryFn: fetchChecklists });

  const filteredChecklists = checklists != null ? filterChecklists(checklists, searchText) : null;

  return (
    <div className="content p-3">
      <NgPageHeader title={pageTitle} />
      <h1>{pageTitle}</h1>

      {isLoading ? (
        <ChecklistListLoadingPlaceholder />
      ) : showError ? (
        <LoadingFailedBox />
      ) : (
        <>
          <CheckListSearchComponent onSearch={setSearchText} />

          <ChecklistListComponent checklists={filteredChecklists} />
        </>
      )}
    </div>
  );
}
